import api from '../api';

export const fetchInformationResources = (data) => api.post('/core/functions/fetchInformationResources', data);

export const fetchInformationResource = (data) => api.post('/core/functions/fetchInformationResource', data);

export const archiveUnarchiveInformationResource = (data) => api.post('/core/functions/archiveUnarchiveInformationResource', data);

export const reviewInformationResource = (data) => api.post('/core/functions/reviewInformationResource', data);
